'use client'

import { useMemo, useState } from 'react'
import { ToolField, ToolResultCard, ToolResultRow, toolCurrency, toolFmt, toolNum } from './tool-inputs'

// Screened topsoil bulk density ≈ 1.3 t/m³; a 40 L bag ≈ 0.04 m³.
const TOPSOIL_DENSITY_T_PER_M3 = 1.3
const BAG_M3 = 0.04

export function TopsoilCalculatorTool() {
  const [length, setLength] = useState('6')
  const [width, setWidth] = useState('4')
  const [depth, setDepth] = useState('15')
  const [price, setPrice] = useState('450')

  const r = useMemo(() => {
    const area = toolNum(length) * toolNum(width)
    const volume = area * (toolNum(depth) / 100) // depth in cm
    const tonnes = volume * TOPSOIL_DENSITY_T_PER_M3
    return { area, volume, tonnes, bags: Math.ceil(volume / BAG_M3), cost: volume * toolNum(price) }
  }, [length, width, depth, price])

  return (
    <div className="grid gap-6 md:grid-cols-[1fr_380px] md:items-start">
      <div className="space-y-5 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Bed / area &amp; depth</h2>
          <div className="mt-3 grid grid-cols-3 gap-3">
            <ToolField label="Length" value={length} onChange={setLength} unit="m" />
            <ToolField label="Width" value={width} onChange={setWidth} unit="m" />
            <ToolField label="Depth" value={depth} onChange={setDepth} unit="cm" step="1" hint="10–20 cm typical" />
          </div>
        </div>
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Price</h2>
          <div className="mt-3 grid grid-cols-2 gap-3">
            <ToolField label="Topsoil price" value={price} onChange={setPrice} unit="R/m³" />
          </div>
        </div>
      </div>

      <ToolResultCard title="Your topsoil estimate">
        <ToolResultRow label="Area" value={`${toolFmt(r.area, 1)} m²`} />
        <ToolResultRow label="Volume" value={`${toolFmt(r.volume, 2)} m³`} />
        <ToolResultRow label="Topsoil needed" value={`${toolFmt(r.tonnes, 2)} t`} />
        <ToolResultRow label="≈ 40 L bags" value={`${r.bags} bags`} />
        <ToolResultRow label="Estimated topsoil cost" value={toolCurrency(r.cost)} strong />
      </ToolResultCard>
    </div>
  )
}
